import useApiQueryData from "../use_api_query_data";
import XNGApiQueryParamObject from "../../../types/xng_api_query_param_object";
import { API_USERS_BACKEND } from "../../api";
import { ClientAssignment, GetClientAssignmentsRequest } from "@xng/xng-backend";

type Data = Awaited<ReturnType<typeof API_USERS_BACKEND.getClientAssignments>>; // generic parameter T is used to define data the type of the useApiQueryData hook 
type QueryParams = GetClientAssignmentsRequest

const useApiQueryClientAssignments = (paramObject:XNGApiQueryParamObject<QueryParams, Data>) => {
  return useApiQueryData(
    {
      queryFn: async () =>
        await API_USERS_BACKEND.getClientAssignments(paramObject.queryParams),
      queryKey: [
        "getClientAssignments",
        paramObject.queryParams.id
      ],
      ...(paramObject.options ?? {})
    }
  );
};

export default useApiQueryClientAssignments;